import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {cacheKeys} from 'api'
import useRefetchQuery from 'hooks/helpers/useRefetchQuery'

import useApi from '../api/useApi'

import useAssetQuery from './useAssetQuery'

export default function useAssetGenerateWallet(asset, options = undefined) {
  const {t} = useTranslation()
  const api = useApi()
  const {enqueueSnackbar} = useSnackbar()
  const {refetchQuery} = useRefetchQuery()
  const [isGenerating, setIsGenerating] = useState(false)

  const {refetchWithTimeout} = useAssetQuery(asset)
  const {mutate, isLoading, ...other} = useMutation(
    () => {
      setIsGenerating(true)
      return api.generateAsset({asset})
    },
    {
      ...options,
      onSuccess: async () => {
        enqueueSnackbar(t('wallet.assets.generateWalletSuccess'), {variant: 'success'})
        refetchWithTimeout.mutateAsync().then(() => {
          setIsGenerating(false)
          refetchQuery([cacheKeys.balanceTotal])
        })
        options?.onSuccess?.()
      },
    },
  )

  return {
    ...other,
    generateWallet: mutate,
    isLoading: isLoading || isGenerating,
  }
}
